import { render, staticRenderFns } from "./SuperAdminTopNavbar.vue?vue&type=template&id=783402b0&"
import script from "./SuperAdminTopNavbar.vue?vue&type=script&lang=js&"
export * from "./SuperAdminTopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports